export enum TransactionConsumerPaymentType {
  TCPMT_UNSET_STATE = 'TCPMT_UNSET_STATE', // Do not use, needed because of proto3 limitations
  TCPMT_OXXOPAY = 'TCPMT_OXXOPAY',
  TCPMT_OTHER = 'TCPMT_OTHER',
  TCPMT_OPENPAY = 'TCPMT_OPENPAY',
  TCPMT_POINTBANK = 'TCPMT_POINTBANK',
}
